import { Navigate, Route, Routes } from 'react-router-dom';
import CustomersPage from '../pages/customers-page';

export const CustomersRoutes = () => {
  return (
    <Routes>
      <Route index element={<CustomersPage />} />
      <Route path=":id" element={<Navigate to="." replace />} />
    </Routes>
  );
};

export default CustomersRoutes;
